module.exports = __webpack_public_path__ + "img/news.8814dfce.svg";